import React, { useState, useRef, useEffect } from 'react'
import styles from "./StoreCatalogCard.module.css"
import { GoImage } from "react-icons/go";
import { BsThreeDotsVertical } from "react-icons/bs";

const DEFAULT_CLASSES = {
    cardContainer: styles.cardContainer,
    cardImageContainer: styles.cardImageContainer,
    cardMenuContainer: styles.cardMenuContainer,
    cardMenuButton: styles.cardMenuButton,
    cardMenuDropdown: styles.cardMenuDropdown,
    cardMenuOption: styles.cardMenuOption,
    cardMenuOptionDanger: styles.cardMenuOptionDanger,
    cardImage: styles.cardImage,
    cardImagePlaceholder: styles.cardImagePlaceholder,
    cardPriceContainer: styles.cardPriceContainer,
    cardPrice: styles.cardPrice,
    cardContentContainer: styles.cardContentContainer,
    draftCard: styles.draftCard,
    cardTitle: styles.cardTitle,
    cardDescription: styles.cardDescription
}

export default function StoreCatalogCard(
    {
        name,
        description,
        image,
        attributeCount,
        activeAttributeCount,
        pricing,
        onClick = () => {},
        onRename = () => {},
        onDelete = () => {},
        type = "product",
        variantMetadata = {},
        showMenu = true,
        classOverride = {},
        styleOverride = {}
    }
) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const classes = { ...DEFAULT_CLASSES, ...classOverride };

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    function handleMenuToggle(event) {
        event.stopPropagation();
        setMenuOpen((prev) => !prev);
    }

    function handleMenuAction(action) {
        return (event) => {
            event.stopPropagation();
            setMenuOpen(false);
            action();
        };
    }

    function formatAttributeCount(attributeCount, activeAttributeCount) {
        if (activeAttributeCount === attributeCount) {
            return `${attributeCount} attributes`;
        }
        return `${activeAttributeCount} / ${attributeCount} active attributes`;
    }
    const isDraftCard = Number(attributeCount || 0) === 0;
    return (
        <div
            className={classes.cardContainer}
            style={styleOverride.cardContainer}
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onClick();
                }
            }}
        >
            <div className={classes.cardImageContainer} style={styleOverride.cardImageContainer}>
                {showMenu && (
                    <div className={classes.cardMenuContainer} ref={menuRef} style={styleOverride.cardMenuContainer}>
                        <button
                            type="button"
                            className={classes.cardMenuButton}
                            style={styleOverride.cardMenuButton}
                            onClick={handleMenuToggle}
                            aria-label="Card options"
                        >
                            <BsThreeDotsVertical size={16} />
                        </button>
                        {menuOpen && (
                            <div className={classes.cardMenuDropdown} style={styleOverride.cardMenuDropdown}>
                                <button
                                    type="button"
                                    className={classes.cardMenuOption}
                                    style={styleOverride.cardMenuOption}
                                    onClick={handleMenuAction(onRename)}
                                >
                                    Rename
                                </button>
                                <button
                                    type="button"
                                    className={`${classes.cardMenuOption} ${classes.cardMenuOptionDanger}`}
                                    style={styleOverride.cardMenuOptionDanger}
                                    onClick={handleMenuAction(onDelete)}
                                >
                                    Delete
                                </button>
                            </div>
                        )}
                    </div>
                )}
                {image?.url ? (
                    <img src={image.url} className={classes.cardImage} style={styleOverride.cardImage} alt={image.alt_text || name} />
                ) : (
                    <GoImage className={classes.cardImagePlaceholder} style={styleOverride.cardImagePlaceholder} />
                )}
                <div className={classes.cardPriceContainer} style={styleOverride.cardPriceContainer}>
                    {isDraftCard? 
                    <p className={classes.cardPrice} style={styleOverride.cardPrice}>Draft</p>
                    : 
                    <p className={classes.cardPrice} style={styleOverride.cardPrice}>{pricing?.display || "Price unavailable"}</p>}
                    
                </div>
                
            </div>
            {type === "product" && (
                <div className={`${classes.cardContentContainer} ${isDraftCard ? classes.draftCard : ""}`} style={styleOverride.cardContentContainer}>
                <h2 className={classes.cardTitle} style={styleOverride.cardTitle}>{name}</h2>
                <p className={classes.cardDescription} style={styleOverride.cardDescription}>{description}</p>
                <p className={classes.cardVariantCount} style={styleOverride.cardVariantCount}>{formatAttributeCount(Number(attributeCount || 0), Number(activeAttributeCount || 0))}</p>
                </div>
                
            )} 
            
            
            {type === "variant" &&(
                <div className={`${classes.cardContentContainer} ${isDraftCard ? classes.draftCard : ""}`} style={styleOverride.cardContentContainer}>
                    <h2 className={classes.cardTitle} style={styleOverride.cardTitle}>{name}</h2>
                    {variantMetadata && Object.keys(variantMetadata).length > 0 && Object.entries(variantMetadata).map(([key, value]) => (
                            <p key={key} className={classes.cardDescription} style={styleOverride.cardDescription}>
                                <strong>{key}:</strong> {typeof value === "object" && value !== null
                                    ? (value.display || value.value || value.quantity || JSON.stringify(value))
                                    : value}
                                    
                            </p>
                            
                    
                    ))}
                    
                </div>
                
            )}
            
        </div>
    )
}
